export const stripMaybes = <T>(
  v: T,
): v is Exclude<Exclude<T, null>, undefined> => v != null
